"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WordOptionsCardWrapper = function WordOptionsCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "multipleChoiceSelected", _descriptor, _this);
      _initializerDefineProperty(_this, "correct", _descriptor2, _this);
      _initializerDefineProperty(_this, "incorrectAnswer", _descriptor3, _this);
      _initializerDefineProperty(_this, "showSentenceHint", _descriptor4, _this);
      _this.clearSelection = function () {
        _this.multipleChoiceSelected = null;
      };
      _this.onClick = function (option) {
        var _this$props$cardState, _this$props$cardState2;
        if (_this.correct || _this.incorrectAnswer || (_this$props$cardState = _this.props.cardState) !== null && _this$props$cardState !== void 0 && _this$props$cardState.revealed || (_this$props$cardState2 = _this.props.cardState) !== null && _this$props$cardState2 !== void 0 && _this$props$cardState2.pendingReveal) {
          if (_state.DeckUI.logger) {
            var _this$props$card, _this$props$cardState3, _this$props$cardState4;
            _state.DeckUI.logger.log('WordOptions onClick ignored', {
              cardId: (_this$props$card = _this.props.card) === null || _this$props$card === void 0 ? void 0 : _this$props$card.id,
              alreadyCorrect: _this.correct,
              hasIncorrectAnswer: Boolean(_this.incorrectAnswer),
              revealed: (_this$props$cardState3 = _this.props.cardState) === null || _this$props$cardState3 === void 0 ? void 0 : _this$props$cardState3.revealed,
              pendingReveal: (_this$props$cardState4 = _this.props.cardState) === null || _this$props$cardState4 === void 0 ? void 0 : _this$props$cardState4.pendingReveal
            });
          }
          return;
        }
        _this.multipleChoiceSelected = option.id;
        _this.props.cardState.selectedOptionText = option.text;
        if (_state.DeckUI.logger) {
          var _this$props$card2;
          _state.DeckUI.logger.log('WordOptions option selected', {
            cardId: (_this$props$card2 = _this.props.card) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.id,
            optionText: option.text,
            correct: Boolean(option.correct)
          });
        }
        if (option.correct) {
          _this.correct = true;
          _state.DeckUI.onCorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, {
            xp: 2,
            xpSlug: 'exercise',
            multipleChoiceOptionId: option.id
          });
        } else {
          _this.incorrect = true;
          _this.incorrectAnswer = option.text;
          _state.DeckUI.onIncorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, option.id);
        }
        setTimeout(_this.clearSelection, 500);
        setTimeout(function () {
          return _state.DeckUI.reveal(_this.props.card, _this.props.cardState);
        }, 500);
      };
      _this.onNextClick = function () {
        _state.DeckUI.advanceCard(_this.props.card, _this.props.cardState, _this.props.userCard);
        _this.incorrectAnswer = null;
      };
      _state.DeckUI.enrichWord(_this.props.card);
      _this.syncMultipleChoiceOptionsToCard();
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "sentenceHintShown",
      get: function get() {
        return this.props.cardState.sentenceHintShown;
      },
      set: function set(value) {
        this.props.cardState.set('sentenceHintShown', value);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _prevProps$card, _this$props$card3, _prevProps$cardState, _this$props$cardState5;
        this.syncMultipleChoiceOptionsToCard();
        if ((prevProps === null || prevProps === void 0 || (_prevProps$card = prevProps.card) === null || _prevProps$card === void 0 ? void 0 : _prevProps$card.id) !== ((_this$props$card3 = this.props.card) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.id) || prevProps !== null && prevProps !== void 0 && (_prevProps$cardState = prevProps.cardState) !== null && _prevProps$cardState !== void 0 && _prevProps$cardState.revealed && !((_this$props$cardState5 = this.props.cardState) !== null && _this$props$cardState5 !== void 0 && _this$props$cardState5.revealed)) {
          this.resetAnswerState();
        }
      }
    }, {
      key: "resetAnswerState",
      value: function resetAnswerState() {
        this.sentenceHintShown = false;
        this.correct = false;
        this.incorrect = false;
        this.incorrectAnswer = null;
        this.multipleChoiceSelected = null;
      }
    }, {
      key: "hasExampleSentence",
      get: function get() {
        var _this$props$card4, _this$props$card$word;
        return _state.DeckUI.showVocabExampleSentences && ((_this$props$card4 = this.props.card) === null || _this$props$card4 === void 0 ? void 0 : _this$props$card4.wordOptionsCard) && (0, _utils.isPresent)((_this$props$card$word = this.props.card.word) === null || _this$props$card$word === void 0 ? void 0 : _this$props$card$word.cardExampleSentence);
      }
    }, {
      key: "showSentenceHintButton",
      get: function get() {
        return this.hasExampleSentence && !this.props.cardState.revealed && !this.sentenceHintShown;
      }
    }, {
      key: "showExampleSentence",
      get: function get() {
        return this.hasExampleSentence && (this.props.cardState.revealed || this.sentenceHintShown);
      }
    }, {
      key: "syncMultipleChoiceOptionsToCard",
      value: function syncMultipleChoiceOptionsToCard() {
        var _card$multipleChoiceO, _correct;
        var card = this.props.card;
        if (!(card !== null && card !== void 0 && card.word)) {
          return;
        }
        var languageId = this.multipleChoiceOptionsLanguageId;
        var existingCorrectOptionText = (_card$multipleChoiceO = card.multipleChoiceOptions) === null || _card$multipleChoiceO === void 0 || (_card$multipleChoiceO = _card$multipleChoiceO.find(function (item) {
          return item.correct;
        })) === null || _card$multipleChoiceO === void 0 ? void 0 : _card$multipleChoiceO.text;
        var correct, sources;
        if ((0, _utils.isPresent)(this.props.numberMultipleChoiceSources)) {
          correct = {
            id: 1,
            text: card.word.formattedDigitSourceText,
            correct: true
          };
          sources = this.props.numberMultipleChoiceSources;
        } else if (card.minimalPairCard) {
          var _card$word$minimalPai;
          correct = {
            id: 1,
            text: card.word.targetText,
            correct: true
          };
          sources = [(_card$word$minimalPai = card.word.minimalPair) === null || _card$word$minimalPai === void 0 ? void 0 : _card$word$minimalPai.targetText];
        } else {
          correct = {
            id: 1,
            text: this.correctSourceText,
            correct: true
          };
          sources = this.falseMultipleChoiceOptions;
        }
        if ((0, _utils.isBlank)((_correct = correct) === null || _correct === void 0 ? void 0 : _correct.text)) {
          return;
        }
        correct.text = (0, _utils.removeArticleFromText)(correct.text, languageId);
        var expectedFalseOptionCount = Math.min(sources.length, 3);
        if ((0, _utils.isPresent)(card.multipleChoiceOptions) && card.multipleChoiceOptions.filter(function (item) {
          return !item.correct;
        }).length >= expectedFalseOptionCount && existingCorrectOptionText === correct.text) {
          return;
        }
        var options = sources.map(function (source, index) {
          return {
            id: index + 2,
            text: (0, _utils.removeArticleFromText)(source, languageId),
            correct: false
          };
        });
        var rand = (0, _lodash.random)(0, 3);
        options.splice(rand, 0, correct);
        card.set('multipleChoiceOptions', options.slice(0, 4));
      }
    }, {
      key: "icons",
      get: function get() {
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (this.props.cardState.revealed) {
          ary.push('vocabCard');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        if (!this.props.cardState.revealed && this.props.card.cardType.slug === 'number_options' && !(0, _utils.isBlank)(this.props.card.word.digitSourceText)) {
          ary.push('toggleMultipleChoice');
        }
        return ary;
      }
    }, {
      key: "showExpandedTarget",
      get: function get() {
        return !_state.DeckUI.user.hideVocabTargetUntilRevealed || !this.props.card.hasTargetVideoClip || this.props.cardState.revealed || this.props.cardState.pendingReveal;
      }
    }, {
      key: "mediaSectionHeight",
      get: function get() {
        return _state.DeckUI.layout.heightForCardSections(3);
      }
    }, {
      key: "sectionHeight",
      get: function get() {
        if (this.props.cardState.revealed || this.props.cardState.pendingReveal) {
          if (this.props.card.hasTargetVideoClip) {
            return _state.DeckUI.layout.heightForCardSections(3);
          }
          return _state.DeckUI.layout.heightForCardSections(2);
        }
        if (this.props.card.hasTargetVideoClip) {
          return _state.DeckUI.layout.contentHeightWithMultipleChoiceButtons(4) - this.mediaSectionHeight;
        }
        return _state.DeckUI.layout.contentHeightWithMultipleChoiceButtons(4);
      }
    }, {
      key: "correctSourceText",
      get: function get() {
        return this.correctSourceTextForLanguage(this.multipleChoiceOptionsLanguageId);
      }
    }, {
      key: "correctSourceTextForLanguage",
      value: function correctSourceTextForLanguage(languageId) {
        var _this$props$card6, _this$props$card$word3;
        if (this.shouldUseMeaningSource) {
          var _this$props$card5;
          var meaningSourceText = this.meaningSourceTextForLanguage(languageId);
          if ((0, _utils.isPresent)(meaningSourceText)) {
            return meaningSourceText;
          }
          if (languageId !== 'EN' && ((_this$props$card5 = this.props.card) === null || _this$props$card5 === void 0 || (_this$props$card5 = _this$props$card5.word) === null || _this$props$card5 === void 0 ? void 0 : _this$props$card5.meaningsCount) > 0) {
            return null;
          }
        }
        if ((0, _utils.isPresent)((_this$props$card6 = this.props.card) === null || _this$props$card6 === void 0 || (_this$props$card6 = _this$props$card6.word) === null || _this$props$card6 === void 0 ? void 0 : _this$props$card6.falseMultipleChoiceOptions)) {
          var sourceInMultipleChoiceLanguage = this.translationSourceForLanguage(this.props.card.word.translationSources, languageId);
          if ((0, _utils.isPresent)(sourceInMultipleChoiceLanguage)) {
            return this.props.card.word.sourceTextWithGenderAbbreviation(sourceInMultipleChoiceLanguage.source, _state.AppUI.user);
          }
          if (languageId === 'EN') {
            var _this$props$card$word2;
            return this.props.card.source || ((_this$props$card$word2 = this.props.card.word.vocabEnSourceListForUser(_state.AppUI.user)) === null || _this$props$card$word2 === void 0 ? void 0 : _this$props$card$word2[0]) || this.props.card.word.vocabSources[0];
          }
          return null;
        }
        return this.props.card.source || ((_this$props$card$word3 = this.props.card.word.vocabEnSourceListForUser(_state.AppUI.user)) === null || _this$props$card$word3 === void 0 ? void 0 : _this$props$card$word3[0]);
      }
    }, {
      key: "multipleChoiceOptionsLanguageId",
      get: function get() {
        var _this$props$card7;
        var requestedLanguageId = (_this$props$card7 = this.props.card) === null || _this$props$card7 === void 0 || (_this$props$card7 = _this$props$card7.word) === null || _this$props$card7 === void 0 ? void 0 : _this$props$card7.falseMultipleChoiceOptionsLanguageId;
        if ((0, _utils.isBlank)(requestedLanguageId) || requestedLanguageId === 'EN') {
          return 'EN';
        }
        return this.hasUsableFalseMultipleChoiceOptionsForLanguage(requestedLanguageId) ? requestedLanguageId : 'EN';
      }
    }, {
      key: "hasUsableFalseMultipleChoiceOptionsForLanguage",
      value: function hasUsableFalseMultipleChoiceOptionsForLanguage(languageId) {
        var correctSourceText = this.correctSourceTextForLanguage(languageId);
        if ((0, _utils.isBlank)(correctSourceText)) {
          return false;
        }
        var correctAnswers = this.correctAnswersForLanguage(languageId).filter(function (item) {
          return (0, _utils.isPresent)(item);
        }).map(function (item) {
          return (0, _utils.removeArticleFromText)(item, languageId);
        });
        var options = this.filteredMultipleChoiceOptions(this.falseMultipleChoiceOptionsForLanguage(languageId), correctAnswers, languageId);
        return new Set(options).size > 0;
      }
    }, {
      key: "shouldUseMeaningSource",
      get: function get() {
        var _AppUI$user, _AppUI$user2;
        return ((_AppUI$user = _state.AppUI.user) === null || _AppUI$user === void 0 ? void 0 : _AppUI$user.showMeanings) && ((_AppUI$user2 = _state.AppUI.user) === null || _AppUI$user2 === void 0 ? void 0 : _AppUI$user2.showVocabMeanings) === true;
      }
    }, {
      key: "meaningSourceText",
      get: function get() {
        var _this$props$card8, _firstMeaning$transla, _this$props$card9;
        var firstMeaning = (0, _lodash.orderBy)(((_this$props$card8 = this.props.card) === null || _this$props$card8 === void 0 || (_this$props$card8 = _this$props$card8.word) === null || _this$props$card8 === void 0 ? void 0 : _this$props$card8.meanings) || [], 'score', 'desc')[0];
        var firstMeaningSource = firstMeaning === null || firstMeaning === void 0 || (_firstMeaning$transla = firstMeaning.translationSourcesForUser(_state.AppUI.user)) === null || _firstMeaning$transla === void 0 || (_firstMeaning$transla = _firstMeaning$transla[0]) === null || _firstMeaning$transla === void 0 ? void 0 : _firstMeaning$transla.source;
        if ((0, _utils.isPresent)(firstMeaningSource)) {
          return firstMeaningSource.textForUser(_state.AppUI.user);
        }
        var firstMeaningPreviewSource = (_this$props$card9 = this.props.card) === null || _this$props$card9 === void 0 || (_this$props$card9 = _this$props$card9.word) === null || _this$props$card9 === void 0 || (_this$props$card9 = _this$props$card9.meaningSourcePreviews) === null || _this$props$card9 === void 0 || (_this$props$card9 = _this$props$card9[0]) === null || _this$props$card9 === void 0 ? void 0 : _this$props$card9.source;
        if ((0, _utils.isPresent)(firstMeaningPreviewSource)) {
          return firstMeaningPreviewSource.textForUser(_state.AppUI.user);
        }
        return null;
      }
    }, {
      key: "meaningSourceTextForMultipleChoiceLanguage",
      get: function get() {
        return this.meaningSourceTextForLanguage(this.multipleChoiceOptionsLanguageId);
      }
    }, {
      key: "meaningSourceTextForLanguage",
      value: function meaningSourceTextForLanguage(languageId) {
        var _this$meaningTranslat;
        var firstMeaningSource = (_this$meaningTranslat = this.meaningTranslationSourceForMultipleChoiceLanguage(languageId)) === null || _this$meaningTranslat === void 0 ? void 0 : _this$meaningTranslat.source;
        if ((0, _utils.isPresent)(firstMeaningSource)) {
          return firstMeaningSource.textForUser(_state.AppUI.user);
        }
        return null;
      }
    }, {
      key: "meaningTranslationSourceForMultipleChoiceLanguage",
      value: function meaningTranslationSourceForMultipleChoiceLanguage(languageId) {
        if (languageId === 'EN') {
          return this.meaningTranslationSourceForLanguage('EN') || this.meaningTranslationSourceForLanguage('EN2');
        }
        return this.meaningTranslationSourceForLanguage(languageId);
      }
    }, {
      key: "translationSourceForLanguage",
      value: function translationSourceForLanguage(translationSources, languageId) {
        if ((0, _utils.isBlank)(languageId) || !(0, _utils.isPresent)(translationSources)) {
          return null;
        }
        return translationSources.find(function (ts) {
          var _ts$source;
          return ((_ts$source = ts.source) === null || _ts$source === void 0 ? void 0 : _ts$source.languageId) === languageId && ((0, _utils.isBlank)(ts.userId) || ts.accepted) && !ts.rejected;
        });
      }
    }, {
      key: "meaningTranslationSourceForLanguage",
      value: function meaningTranslationSourceForLanguage(languageId) {
        var _this$props$card0, _this$props$card1;
        var firstMeaning = (0, _lodash.orderBy)(((_this$props$card0 = this.props.card) === null || _this$props$card0 === void 0 || (_this$props$card0 = _this$props$card0.word) === null || _this$props$card0 === void 0 ? void 0 : _this$props$card0.meanings) || [], 'score', 'desc')[0];
        return this.translationSourceForLanguage(firstMeaning === null || firstMeaning === void 0 ? void 0 : firstMeaning.translationSourcesForUser(_state.AppUI.user), languageId) || this.translationSourceForLanguage((_this$props$card1 = this.props.card) === null || _this$props$card1 === void 0 || (_this$props$card1 = _this$props$card1.word) === null || _this$props$card1 === void 0 ? void 0 : _this$props$card1.meaningSourcePreviews, languageId);
      }
    }, {
      key: "falseMultipleChoiceOptions",
      get: function get() {
        var languageId = this.multipleChoiceOptionsLanguageId;
        var correctAnswers = this.correctAnswersForLanguage(languageId).filter(function (item) {
          return (0, _utils.isPresent)(item);
        }).map(function (item) {
          return (0, _utils.removeArticleFromText)(item, languageId);
        });
        var options = _toConsumableArray(new Set(this.filteredMultipleChoiceOptions(this.falseMultipleChoiceOptionsForLanguage(languageId), correctAnswers, languageId)));
        if (languageId !== 'EN' || options.length >= 3) {
          return (0, _lodash.shuffle)(options);
        }
        var constantOptions = (0, _lodash.shuffle)(_toConsumableArray(new Set(this.filteredMultipleChoiceOptions(this.sourceListForWordType, [].concat(_toConsumableArray(correctAnswers), _toConsumableArray(options)), languageId))));
        return (0, _lodash.shuffle)([].concat(_toConsumableArray(options), _toConsumableArray(constantOptions.slice(0, 3 - options.length))));
      }
    }, {
      key: "filteredMultipleChoiceOptions",
      value: function filteredMultipleChoiceOptions(sourceList, correctAnswers, languageId) {
        return sourceList.map(function (item) {
          return item === null || item === void 0 ? void 0 : item.trim();
        }).filter(function (item) {
          return (0, _utils.isPresent)(item) && !correctAnswers.includes((0, _utils.removeArticleFromText)(item, languageId));
        });
      }
    }, {
      key: "correctAnswersForLanguage",
      value: function correctAnswersForLanguage(languageId) {
        var _this$props$card10,
          _this2 = this;
        if (languageId === 'EN') {
          return [].concat(_toConsumableArray(this.actualEnglishSourceTexts), [this.correctSourceTextForLanguage(languageId)]);
        }
        return [].concat(_toConsumableArray(this.translationSourcesForLanguage((_this$props$card10 = this.props.card) === null || _this$props$card10 === void 0 || (_this$props$card10 = _this$props$card10.word) === null || _this$props$card10 === void 0 ? void 0 : _this$props$card10.translationSources, languageId).map(function (item) {
          return _this2.props.card.word.sourceTextWithGenderAbbreviation(item.source, _state.AppUI.user);
        })), [this.correctSourceTextForLanguage(languageId)]);
      }
    }, {
      key: "falseMultipleChoiceOptionsForLanguage",
      value: function falseMultipleChoiceOptionsForLanguage(languageId) {
        var _this$props$card11;
        var word = (_this$props$card11 = this.props.card) === null || _this$props$card11 === void 0 ? void 0 : _this$props$card11.word;
        if ((0, _utils.isBlank)(languageId) || (0, _utils.isBlank)(word)) {
          return [];
        }
        if (languageId === word.falseMultipleChoiceOptionsLanguageId) {
          var options = (word.falseMultipleChoiceOptions || '').split(',').map(function (item) {
            return item.trim();
          }).filter(function (item) {
            return (0, _utils.isPresent)(item);
          });
          if ((0, _utils.isPresent)(options)) {
            return options;
          }
        }
        if (languageId === 'EN' && (0, _utils.isPresent)(word.falseMultipleChoiceOptionsEn)) {
          return word.falseMultipleChoiceOptionsEn.split(',').map(function (item) {
            return item.trim();
          }).filter(function (item) {
            return (0, _utils.isPresent)(item);
          });
        }
        return [];
      }
    }, {
      key: "translationSourcesForLanguage",
      value: function translationSourcesForLanguage(translationSources, languageId) {
        if ((0, _utils.isBlank)(languageId) || !(0, _utils.isPresent)(translationSources)) {
          return [];
        }
        return translationSources.filter(function (ts) {
          var _ts$source2;
          return ((_ts$source2 = ts.source) === null || _ts$source2 === void 0 ? void 0 : _ts$source2.languageId) === languageId && ((0, _utils.isBlank)(ts.userId) || ts.accepted) && !ts.rejected;
        });
      }
    }, {
      key: "actualEnglishSourceTexts",
      get: function get() {
        var _this$props$card12,
          _this3 = this;
        return this.translationSourcesForLanguages((_this$props$card12 = this.props.card) === null || _this$props$card12 === void 0 || (_this$props$card12 = _this$props$card12.word) === null || _this$props$card12 === void 0 ? void 0 : _this$props$card12.translationSources, ['EN', 'EN2']).map(function (item) {
          return _this3.props.card.word.sourceTextWithGenderAbbreviation(item.source, _state.AppUI.user);
        });
      }
    }, {
      key: "translationSourcesForLanguages",
      value: function translationSourcesForLanguages(translationSources, languageIds) {
        var _this4 = this;
        if (!(0, _utils.isPresent)(languageIds)) {
          return [];
        }
        return languageIds.reduce(function (ary, languageId) {
          return ary.concat(_this4.translationSourcesForLanguage(translationSources, languageId));
        }, []);
      }
    }, {
      key: "sourceListForWordType",
      get: function get() {
        var _this$props$card13;
        var wordTypeAbbreviation = (_this$props$card13 = this.props.card) === null || _this$props$card13 === void 0 || (_this$props$card13 = _this$props$card13.word) === null || _this$props$card13 === void 0 || (_this$props$card13 = _this$props$card13.wordType) === null || _this$props$card13 === void 0 ? void 0 : _this$props$card13.abbreviation;
        if (wordTypeAbbreviation && (0, _lodash.keys)(_constants.SourceList).includes(wordTypeAbbreviation)) {
          return _toConsumableArray(new Set(Object.values(_constants.SourceList[wordTypeAbbreviation]).reduce(function (ary, sourceList) {
            return ary.concat(sourceList);
          }, [])));
        }
        return _constants.SourceList['noun']['A1'];
      }
    }, {
      key: "multipleChoiceOptions",
      get: function get() {
        return this.props.card.multipleChoiceOptions || [];
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          sentenceHintShown: this.sentenceHintShown,
          showSentenceHint: this.showSentenceHint,
          showSentenceHintButton: this.showSentenceHintButton,
          hasExampleSentence: this.hasExampleSentence,
          showExampleSentence: this.showExampleSentence,
          multipleChoiceOptions: this.multipleChoiceOptions,
          multipleChoiceSelected: this.multipleChoiceSelected,
          onClick: this.onClick,
          correct: this.correct,
          incorrectAnswer: this.incorrectAnswer,
          mediaSectionHeight: this.mediaSectionHeight,
          sectionHeight: this.sectionHeight,
          icons: this.icons,
          onNextClick: this.onNextClick,
          showExpandedTarget: this.showExpandedTarget
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "multipleChoiceSelected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "correct", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "incorrectAnswer", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "resetAnswerState", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "resetAnswerState"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasExampleSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasExampleSentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSentenceHintButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSentenceHintButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showExampleSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showExampleSentence"), _class2.prototype), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "showSentenceHint", [_mobx.action], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      var _this5 = this;
      return function (event) {
        var _event$stopPropagatio;
        event === null || event === void 0 || (_event$stopPropagatio = event.stopPropagation) === null || _event$stopPropagatio === void 0 || _event$stopPropagatio.call(event);
        _this5.sentenceHintShown = true;
      };
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "syncMultipleChoiceOptionsToCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "syncMultipleChoiceOptionsToCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showExpandedTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showExpandedTarget"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mediaSectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mediaSectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctSourceText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctSourceText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "multipleChoiceOptionsLanguageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "multipleChoiceOptionsLanguageId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shouldUseMeaningSource", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldUseMeaningSource"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "meaningSourceText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "meaningSourceText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "meaningSourceTextForMultipleChoiceLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "meaningSourceTextForMultipleChoiceLanguage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "falseMultipleChoiceOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "falseMultipleChoiceOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "actualEnglishSourceTexts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "actualEnglishSourceTexts"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sourceListForWordType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sourceListForWordType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "multipleChoiceOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "multipleChoiceOptions"), _class2.prototype), _class2)) || _class;
};
WordOptionsCardWrapper.displayName = 'WordOptionsCardWrapper';
var _default = exports["default"] = WordOptionsCardWrapper;